import {memo, useState} from "react";
import Button from "../Button/Button";
import "./style.css";
import ArrowSvg from "../../../icons/ArrowSvg";
import {Typography} from "@mui/material";

function MenuDropdown({ title, total, children, open = false, id, onSelectAll = () => { }, showSelectAll = true }) {
    const [isOpen, setOpen] = useState(open);

    return (
        <div className="dropdown">
            <div className="dropdown__rov main-border-bottom d-flex">
                <Typography variant="h6" fontSize={16}>{title}</Typography>
                <Typography variant="body1" className={"dropdown-options"}>Всего: {total}</Typography>

                {showSelectAll && <Button
                    onClick={() => onSelectAll(id)}
                    className="dove-color main-border-bottom-current fz12 dropdown-options"
                    children="Выбрать все"
                />}

                <Button
                    className="strokewidth3 open-more-btn d-flex align-items-center"
                    children={<ArrowSvg className={!isOpen ? 'arrowRotated': ''} />}
                    onClick={() => setOpen(!isOpen)}
                />

            </div>

            {isOpen && <div className="dropdown__content">
                {showSelectAll && <Button
                        className="dove-color-module main-border-bottom-current fz12"
                        children="Выбрать все"
                    />
                }
                {children}
            </div>}
        </div>
    );
}

export default memo(MenuDropdown);
